import { Injectable } from "@angular/core";
import { Account, Flashcards } from "./flashcard.model";
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class Flashcards_item {
    access = access_item;
}
export const access_item  = [
  { name: 'Public', value: true },
  { name: 'Private', value: false }
];
export function initFlashcards() {
    return {
      id: uuidv4(),
      access: true,
      icon: '💡',
      title: '',
      tags: [],
      data: [],
    }
}

export function initCard() {
  return {
    question: '',
    answer: '',
    learn: false,
  }
}


export function initAccount_util(): Account {
  return {
    name: `User_${uuidv4().slice(0,4)}`,
    password: uuidv4().slice(0,8),
  }
}

export function initHelpFlashcards(): Flashcards {
  return {
    id: uuidv4(),
    access: false,
    icon: '📕',
    title: '사용법 노트 (How to Use)',
    tags: ['How to Use', `Beginner's Guide`],
    data: [
    { question: "🗑️ 삭제하는 방법",answer: "목록에서 카드를 오른쪽에서 왼쪽으로 슬라이드하면 삭제 버튼이 나타납니다.", learn: false},
    {question: "✏️ 수정하는 방법", answer: "목록에서 카드를 왼쪽에서 오른쪽으로 슬라이드하면 버튼이 나타납니다.", learn: false},
    {question: '👁️ 가리기 해제 유지 버튼', answer: '카드 화면에서 우측 상단의 버튼을 눌러 가리기 설정과 해제를 할 수 있습니다.', learn: false},
    {question: '✔️ 암기 완료 체크', answer: '1. 목록에서 우측 ⚪ 버튼을 눌러 암기 완료 설정을 할 수 있습니다.\n2. 카드에서 상단 ⚪ 버튼을 눌러 암기 완료 설정을 할 수 있습니다.', learn: false},
    {question: '🔒 노트 공개 여부 설정', answer: "노트 생성 시\n1. 'Private' 설정으로 개인 노트를 만들 수 있습니다.\n2. 'Public' 설정으로 노트를 자동 공유할 수 있습니다.", learn: false},
    {question: '🏷️ 태그 설정', answer: '1. 태그와 제목 설정으로 노트에 대한 설명을 기록할 수 있습니다.\n2. 공유 게시판 검색을 통해 제목과 태그에 해당하는 노트를 찾을 수 있습니다.', learn: false}
    ],
  }
}